import request from '../request.js'


/**
* 描述： 保存企业账户
* 接口管理员：叶凡
* 参数： 
{
}
*/
export const saveTenantAccount = function (data) {
    return request({
        url: 'tenantAccount/saveTenantAccount',
        method: 'post',
        data
    })
}

/**
* 描述： 获取企业账户列表
* 接口管理员：叶凡
* 参数： 
{
}
*/
export const getTenantAcounts = function (data) {
    return request({
        url: 'tenantAccount/getTenantAcounts',
        method: 'post',
        data
    })
}

/**
* 描述： 删除企业账户
* 接口管理员：叶凡
* 参数： 
{
}
*/
export const deleteTenantAcount = function (data) {
    return request({
        url: 'tenantAccount/deleteTenantAcount',
        method: 'post',
        data,
        requestConfig: {
            showLoading: true
        },
    })
}

/**
* 描述： 切换默认账户
* 接口管理员：叶凡
* 参数： 
{
}
*/
export const changeDefaultAcount = function (data) {
    return request({
        url: 'tenantAccount/changeDefaultAcount',
        method: 'post',
        data,
        requestConfig: {
            showLoading: true
        },
    })
}

/**
* 描述：保存企业数据
* 接口管理员：郑志会
* 参数： 
{
}
*/
export const saveOrUpdate = function (data) {
    return request({
        url: 'sysTenant/saveOrUpdate',
        method: 'post',
        data
    })
}
/**
* 描述：回显编辑企业数据
* 接口管理员：郑志会
* 参数： 
{
}
*/
export const getObjectById = function (data) {
    return request({
        url: 'sysTenant/getObjectById',
        method: 'post',
        data
    })
}
/**
* 描述：单位性质码表
* 接口管理员：郑志会
* 参数： 
{
}
*/
export const getDictsByKey = function (data) {
    return request({
        url: 'busDict/getDictsByKey',
        method: 'post',
        data
    })
}
/**
* 描述：所属行业码表
* 接口管理员：郑志会
* 参数： 
{
}
*/
export const getIndustryCodeTree = function (data) {
    return request({
        url: 'industryCode/getIndustryCodeTree',
        method: 'post',
        data
    })
}

/**
* 描述：所属单位列表
* 接口管理员：郑志会
* 参数： 
{
}
*/
export const getListTenants = function (data) {
    return request({
        url: 'sysTenant/listTenants',
        method: 'post',
        data
    })
}

const getTreeTableList = function (data) {
    return request({
        url: 'sysTenant/getTreeTableList',
        method: 'post',
        data
    })
}
// const saveOrUpdate = function (data) {
//     return request({
//         url: 'sysTenant/saveOrUpdate',
//         method: 'post',
//         data
//     })
// }

const deleteById = function (data) {
    return request({
        url: 'sysTenant/deleteById',
        method: 'post',
        data
    })
}

// const getObjectById = function (data) {
//     return request({
//         url: 'sysTenant/getObjectById',
//         method: 'post',
//         data
//     })
// }


export {
    getTreeTableList,
    deleteById,
}